import Design from './Design.container';

export default Design;
